import Portal from './portal/Portal';
import Authentication from "./authentication/Authentication";
import FirebaseProvider from "./firebase/FirebaseProvider";
import {connect} from "react-redux";
import {selectUserId} from "../redux/selectors/editor";
import {ThemeProvider, StyledEngineProvider, createTheme, Theme} from '@mui/material/styles';
import {responsiveFontSizes} from "@mui/material";
import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/tracing";
import { LicenseInfo } from '@mui/x-data-grid-pro';
import ConfirmProvider from '../utility/ConfirmProvider';

LicenseInfo.setLicenseKey('8e593914b1cd6a57d7a6487e15be857bT1JERVI6Mzk2NzksRVhQSVJZPTE2Nzg5MDE5OTcwMDAsS0VZVkVSU0lPTj0x');

declare global {
    namespace NodeJS {
        interface ProcessEnv {
            REACT_APP_VERSION: string;
        }
    }
}

declare module '@mui/material/styles' {
    interface Palette {
        interTitle: Palette['primary'];
        comment: Palette['primary'];
        commentHighlight: Palette['primary'];
        cellComment: Palette['primary'];
        cellSelected: Palette['primary'];
        search: Palette['primary'];
        spelling: Palette['primary'];
        grammar: Palette['primary'];
    }
    interface PaletteOptions {
        interTitle: PaletteOptions['primary'];
        comment: PaletteOptions['primary'];
        commentHighlight: PaletteOptions['primary'];
        cellComment: PaletteOptions['primary'];
        cellSelected: PaletteOptions['primary'];
        search: PaletteOptions['primary'];
        spelling: PaletteOptions['primary'];
        grammar: PaletteOptions['primary'];
    }
}

declare module '@mui/styles/defaultTheme' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

interface IProps {
    user: string
}
const customTheme = {
    palette: {
        interTitle: { contrastText: "#242424", dark: "#7f5b2c", light: "#fdb557", main: "#fdb557" },
        comment: { contrastText: "yellow", dark: "yellow", light: "yellow", main: "yellow" },
        cellComment: { contrastText: "#608A32", dark: "#608A32", light: "#608A32", main: "#608A32" },
        cellSelected: { contrastText: "rgba(25, 118, 210, 0.25)", dark: "rgba(25, 118, 210, 0.25)", light: "rgba(25, 118, 210, 0.25)", main: "rgba(25, 118, 210, 0.25)" },
        commentHighlight: { contrastText: "orange", dark: "orange", light: "orange", main: "orange" },
        grammar: { contrastText: "green", dark: "green", light: "green", main: "green" },
        search: { contrastText: "salmon", dark: "salmon", light: "salmon", main: "salmon" },
        spelling: { contrastText: "red", dark: "red", light: "red", main: "red" }
    }
};

Sentry.init({
    dsn: "https://a840917caab949ed8d1b7ffa733d1d35@o1152187.ingest.sentry.io/6230058",
    environment: process.env.REACT_APP_MODE === "local" ? "development" : process.env.REACT_APP_MODE,
    integrations: [
        new BrowserTracing()
    ],
    release: process.env.REACT_APP_VERSION,
    tracesSampleRate: 1.0
});
function App({user}: IProps) {
    const theme = responsiveFontSizes(createTheme(customTheme));

    // Set some styles on the main portal
    document.body.style.overflow = "hidden";
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <FirebaseProvider user={user}>
                    <Authentication>
                        <ConfirmProvider>
                            <Portal/>
                        </ConfirmProvider>
                    </Authentication>
                </FirebaseProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}
const mapStateToProps = (store: never) => ({
    user: selectUserId(store)
});

export default connect(mapStateToProps, {
})(App);
